// TODO: (important) Finalize this file and remove eslint-disable after approval has been confirmed. Extract any remaining text from the file and add it to the appropriate i18n file.
/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { Component } from "react";

import i18n from "i18n-react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ContentHeader from "components/ContentHeader";
import DashboardChart from "components/DashboardChart";
import RewardMenu from "components/RewardMenu";

import APIHandler from "config/APIHandler";
import StorageHandler from "config/StorageHandler";

import BadgeContainer from "views/BadgeView/BadgeContainer";
import Badge from "views/BadgeView/IncentiveBadge";

import BookingState from "../BookingsView/BookingState";
// eslint-disable-next-line import/order
import { baseAppId, storageKeys } from "settings";

export default class DashboardView extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      bookings: [],
      contests: [],
      show: {},
      activeBtn: "View All",
    };
  }

  async componentDidMount() {
    this.getBookingsData();
    this.getIncentivesData();
  }

  getBookingsData = () => {
    try {
      this.setState({ loading: true });
      StorageHandler.load(storageKeys.accessToken).then(async (token) => {
        console.log(token);
        if (!token) {
          window.location.href('/logout');
        }
        const result = await APIHandler.getRewards(baseAppId, token);

        const { response: bookings } = result;

        if (Array.isArray(bookings) && bookings.length > 0) {
          this.setState({
            bookings,
            show: {
              showKey: "View All",
              "View All": true,
              data: [...bookings],
            },
            loading: false,
          });
        }
        this.setState({ loading: false });
      });
    } catch (error) {
      this.setState({ bookings: [], loading: false });
    }
  };

  getIncentivesData = () => {
    try {
      StorageHandler.load(storageKeys.lang).then(async (lang) => {
        const result = await APIHandler.getContests(baseAppId, {
          currentDate: new Date().toISOString(),
          marketFilter: [{ id: lang.code.toUpperCase() }],
        });
        if (Array.isArray(result) && result.length > 0) {
          this.setState({ contests: result });
        }
      });
    } catch (error) {
      this.setState({ contests: [] });
    }
  };

  setShow = (key, booking) => {
    const { show } = this.state;

    this.setState({ activeBtn: key });

    const updatedShow = Object.keys(show).reduce((acc, item) => {
      acc[item] = item === key;
      return acc;
    }, {});

    if (booking.length >= 0) {
      updatedShow.showKey = key;
      updatedShow.data = [...booking];

      this.setState({ show: updatedShow });
    }
  };

  render() {
    const { loading, bookings, contests, show, activeBtn } = this.state;

    const columns = [
      {
        name: "Confirm Number",
        selector: (row) => row.booking_number,
        sortable: true,
      },
      {
        name: "Flight Number",
        selector: (row) => row.reservation_number,
        sortable: true,
      },
      {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
      },
      {
        name: "Depature Date",
        selector: (row) => row.departure_date,
        sortable: true,
        hide: "sm",
      },
      {
        name: "Last Name",
        selector: (row) => row.agent_last_name,
        sortable: true,
      },
      {
        name: "Total Travelers",
        selector: (row) => row.number_of_guests,
        sortable: true,
        hide: "md",
      },
      {
        name: "Total Nights",
        selector: (row) => row.length_of_stay,
        sortable: true,
      },
    ];

    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }

    return (
      <div className="contentContainer dashboardView">
        <RewardMenu />

        <section className="headerFirst">
          <ContentHeader
            header={i18n.translate("rewards.dashboardView.title")}
            subtitle={i18n.translate("rewards.dashboardView.subtitle")}
          />
        </section>

        <hr />

        <div className={`DashboardView ${loading ? "overflow-hidden" : ""}`}>
          <div className="dashboardHolder">
            <div className="progress">
              {!loading && (
                <React.Fragment>
                  <div className="tableNav">
                    {Object.entries(BookingState)
                      .sort(([, valueA], [, valueB]) => valueB - valueA)
                      .map(([key]) => {
                        const booking = bookings.filter(({ status }) =>
                          BookingState[key].status.includes(status)
                        );

                        return (
                          <div
                            key={key}
                            onClick={() => this.setShow(key, booking)}
                            aria-hidden
                          >
                            <button
                              className={
                                activeBtn === key ? "btn active" : "btn"
                              }
                            >
                              {key === "Approved Entries" && (
                                <FontAwesomeIcon icon={["fas", "check"]} />
                              )}
                              {key === "Pending Entries" && (
                                <FontAwesomeIcon icon={["fas", "clock"]} />
                              )}
                              {key === "Declined Entries" && (
                                <FontAwesomeIcon icon={["fas", "ban"]} />
                              )}
                              {key === "View All" && (
                                <FontAwesomeIcon icon={["fas", "th-list"]} />
                              )}

                              <span>{booking.length}</span>
                              <span
                                className="head"
                                dangerouslySetInnerHTML={{
                                  __html: i18n
                                    .translate(
                                      `rewards.dashboardView.state.${key
                                        .split(" ")
                                        .join("")
                                        .replace(/^./, (str) =>
                                          str.toLowerCase()
                                        )}`
                                    )
                                    .replace(" ", "<br/>"),
                                }}
                              />
                            </button>
                          </div>
                        );
                      })}
                  </div>

                  <ContentHeader
                    header={i18n.translate("rewards.dashboardView.manage")}
                    subtitle={i18n.translate("rewards.dashboardView.manageSub")}
                  />

                  <div className="table-booking">
                    <DataTable
                      className="bookings-table"
                      columns={columns}
                      data={show?.data}
                      defaultSortFieldId={1}
                      noDataComponent={
                        <div>
                          <br />
                          {i18n.translate("rewards.dashboardView.noBookings")}
                          <br />
                          <br />
                        </div>
                      }
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>

        {mobile && (
          <style>
            {
              "\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }"
            }
          </style>
        )}
      </div>
    );
  }
}
